import { watch, computed, unref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRoute, useRouter } from 'vue-router'
import { $axios, $queryClient } from '@/boot/initApi'

export default ({ filters }) => {
  const $route = useRoute()
  const $router = useRouter()

  return {
    showBrand: ({ id, enabled = true } = {}) =>
      useQuery({
        queryKey: computed(() => ['brands', unref(id)]),
        queryFn: async () => {
          const { data } = await $axios.get(`/api/brands/${unref(id)}`)
          // console.log('%cFetching brand data for ID:', 'color:lime', data)
          return data?.id ? data : null
        },
        enabled,
        staleTime: 1000 * 60 * 5
      }, $queryClient),

    showPresentation: ({ id, enabled = true } = {}) =>
      useQuery({
        queryKey: computed(() => ['presentations', unref(id)]),
        queryFn: async () => {
          const { data } = await $axios.get(`/api/presentations/${unref(id)}`)
          return data?.id ? data : null
        },
        enabled,
        staleTime: 1000 * 60 * 5
      }, $queryClient),

    showSmpc: ({ id, enabled = true } = {}) =>
      useQuery({
        queryKey: computed(() => ['smpcs', unref(id)]),
        queryFn: async () => {
          const { data } = await $axios.get(`/api/smpcs/${unref(id)}`)
          return data?.id ? data : null
        },
        enabled,
        staleTime: 1000 * 60 * 5
      }, $queryClient),

    clearAllFilters: () => {
      const query = { ...$route.query }
      for (const filter in filters.value) {
        delete query[filter]
      }
      $router.replace({ query })
    },

    indexCountries: ({ enabled = true } = {}) => {
      const query = useQuery({
        queryKey: ['countries'],
        queryFn: async () => {
          const { data } = await $axios.get('/api/countries')
          return data ?? []
        },
        enabled,
        staleTime: Infinity
      }, $queryClient)
      watch(query.data, d => {
        if (d) filters.value.country.options = d
      }, { immediate: true })
      return query
    }
  }
}
